import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_TRACKING_ID || 'G-GNS42TJJ4Q';
    
    if (typeof window.gtag === 'function' && gaId) {
      window.gtag('config', gaId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};